export default {
	wsURL: process.env.VUE_APP_API_WS_URL,
	// baseURL: 'http://' //TESTE
	baseURL: process.env.VUE_APP_API_URL //local
	// baseURL: 'http://', //HOMOLOG
	// baseURL: 'http://34.133.227.200' //PRODUCAO
	
}